import * as Sentry from '@sentry/react';

import { BrowserTracing } from '@sentry/tracing';

import {
  findPersonEmail,
  findPersonPhoneNumber,
} from './components/Person/utils';
import { loadUser } from './utils';

import env from '../env';
import { history } from './store';

const ignoredErrors = [
  `Network Error`, // axios
  `AxiosError`,
  `status code 400`, // permissions errors
  `status code 401`,
  `status code 403`,
  `NetworkError`, // EE
  `MediaError`,
  `_controller`,
  `this.ctx.currentTime`,
  `reading 'milliseconds'`,
  `reading 'currentTime'`,
  `Failed to fetch`,
  `this._transmuxer is null`,
  `Submit Validation Failed`, // redux-form validation
  `Illegal invocation`, // gtag - https://xgwang.me/posts/you-may-not-know-beacon/#it-may-throw-error%2C-be-sure-to-catch
  `Non-Error exception captured`, // Non-Error
  `Non-Error promise rejection`,
  `ResizeObserver loop limit exceeded`, // https://stackoverflow.com/a/50387233
];

export const captureException = (error) => Sentry.captureException(error);

export const sentryInit = () => {
  const user = loadUser();

  Sentry.init({
    dsn: env?.SENTRY_DNS,
    environment: env?.APP_ENV,
    release: `carson-admin-site@${process.env.REACT_APP_VERSION}`,
    integrations: [
      new Sentry.Replay(),
      new BrowserTracing({
        tracingOrigins: [
          'localhost',
          'api.carson.live',
          'releaseapi.carson.live',
          'stageapi.carson.live',
          'devapi.carson.live',
          /^\//,
        ],
        routingInstrumentation: Sentry.reactRouterV5Instrumentation(history),
      }),
    ],
    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    ignoreErrors: ignoredErrors,
    beforeSend: (event, hint) => {
      const error = hint?.originalException?.stack;
      const errorName = hint?.originalException?.name;

      // do not send EE errors like
      // https://sentry.io/share/issue/bcbbb9317ffd4d94baa915a1f665523a/

      // https://sentry.io/share/issue/5f4a718c287e47ba815bdb3ee57ef4ff/

      // do not send Axios network errors like
      // https://sentry.io/share/issue/2e5232a493914c7eb8c1e2a7069325c2/

      // do not send Axios 401 Unauthorized errors like
      // https://sentry.io/share/issue/feca0acd1dc343b4a1c20e5455dd83ce/

      const isIgnoredError = Boolean(
        ignoredErrors.find(
          (msg) => error?.includes(msg) || errorName?.includes(msg),
        ),
      );

      if (isIgnoredError) return null;

      return event;
    },
  });

  Sentry.configureScope((scope) => {
    scope.setTag('source', 'Admin Site');
    if (user) {
      scope.setUser({
        firstName: user?.firstName,
        lastName: user?.lastName,
        id: user?.id,
        phoneNumber: findPersonPhoneNumber(user),
        email: findPersonEmail(user),
      });
    }
  });
};
